<template>
  <div>
    <mdb-mask
      overlay="whitee-light"
      class="d-flex justify-content-center align-items-center mask-background"
    >
      <mdb-container>
        <mdb-row class="mb-3">
          <mdb-col md="9" class="text-center" style="margin-left: 12%; margin-top: 5%;">
            <mdb-card class="card-login">
              <mdb-card-body class="mx-5">
                <mdb-row>
                  <mdb-col md="7">
                    <div class="text-center">
                      <img
                        alt="Logo MyFrac"
                        src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Myfrac_logo@3x.png"
                        class="Myfrac-logo"
                      />
                      <div class="Rectangle-1">
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                        <p style="text-align: justify;">
                         Usuario <span style="font-family: OpenSans-Bold;">{{user.email}}</span> crea y confirma tu contraseña con al menos 8 caracteres que incluyan un número y una mayúscula.
                        </p>
                      </div>

                      <form class="needs-validation" novalidate @submit="login" oninput='pass2.setCustomValidity(pass2.value != pass1.value ? "la contraseña no conciden." : "")' >
                        <div>
                          <div class="form-group">
                            <input
                              type="password"
                              name="pass1"
                              class="form-control text-input input-style"
                              required
                              pattern="^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,}$"
                              placeholder="Contraseña"
                              minlength="8"
                              v-model="password"
                            />
                            <div class="invalid-feedback">Tu contraseña debe contener al menos un número y una mayúscula. No se aceptan caracteres especiales</div>
                          </div>
                          <div class="form-group">
                          <input
                              type="password"
                              name="pass2"
                              class="form-control text-input input-style"
                              pattern="^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,}$"
                              required
                              placeholder="Confirma tu contraseña"
                              v-model="repeatPassword"
                            />
                            <div class="invalid-feedback">La constraseña debe ser la misma</div>
                          </div>
                        </div>
                        <div class="text-center mb-3 mt-5" v-if="!isLoding">
                          <mdb-btn type="submit" class="btn-block z-depth-1a button-reg">Registrar</mdb-btn>
                        </div>
                        <div class="text-center mb-3 mt-5" v-if="isLoding">
                    <mdb-btn
                      type="submit"
                      class="btn-block z-depth-1a button-reg"
                      disabled
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    Cargando...
                    </mdb-btn>
                        </div>
                      </form>
                      <img
                        alt="card footer"
                        class="mt-4"
                        src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Smart_Object.png"
                      />
                    </div>
                  </mdb-col>
                  <mdb-col md="4" style="bottom: 20px;">
                    <img
                      alt="imagen complementaria"
                      src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Rectangle1.png"
                    />
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-mask>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../server.js";
import Swal from "sweetalert2";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbBtn,
  mdbIcon,
  mdbView,
  mdbMask
} from "mdbvue";

export default {
  name: "completeRegister",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask
  },
  data() {
    return {
      password: "",
      repeatPassword: "",
      isLoding: false,
      uuidUser:"",
      user:[],
    };
  },
  methods: {
    login(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      let aux = this;
      var compare = aux.password.localeCompare(aux.repeatPassword)
      var re = RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]{8,}$")


      if(re.test(aux.password) && compare == 0){
        aux.isLoding = true;

        var userAux = new Object();
        userAux.uuid = aux.user.uuid;
        userAux.password = aux.password;

        var data = JSON.stringify(userAux);
        Axios.post(Servers.serverApi+'api/users/newPassword', data,{
          headers:{
            "Content-Type": "application/json"

          }

        }).then(function(response){
          aux.showMessageSucces()
        }).catch(error =>{
           console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });


      }
    
    },

    getUser(uuid){
      let aux = this;
      Axios.get(Servers.serverApi+'api/users/findUser/'+uuid,{
        headers:{
          "Content-Type": "application/json"
        }

      }).then(function(response){
        if(response.data==""){
           Swal.fire({
        title: "<span style='font-size: 20px'>Ha ocurrido un error</span>",
        html: "<span style='font-size: 12px'>No existe el usuario solicitado, por favor contacte a soporte MyFrac</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
           window.location.href="/home"
        }
      });
     
         
        }
        aux.user=response.data;
        
      }).catch(error =>{
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);

      })
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function() {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Registro completado!</span>",
        html: "<span style='font-size: 12px;'>Ahora ya puedes iniciar sesión con tu usuario y contraseña para administrar tu información.</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
          if(this.user.idUsersTypes==15){
            window.location.href="./?type=contractor"
          }else{
            window.location.href="/home"
          }
        }
      });
    },
  },
  created(){
    if(this.$route.query.type != "register" || this.$route.query.uuid === undefined){
      Swal.fire({
        title: "<span style='font-size: 20px'>Ha ocurrido un error</span>",
        html: "<span style='font-size: 12px'>No tienes permiso para acceder a este recurso</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
           window.location.href="/home"
        }
      });
     
     
     
    }
    this.getUser(this.$route.query.uuid);
  }
};
</script>

<style scoped>
.card-login {
  border-radius: 8px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  width: 820px;
  height: 572px;
  border: solid 2px #ebebeb;
}

.Myfrac-logo {
  width: 250px;
  height: auto;
  margin-top: 15px;
  object-fit: contain;
}

.button-reg {
  width: 390px;
  height: auto;
  font-family: OpenSans-Semibold;
  font-size: 16px;
  border-radius: 2px;
  background-color: #0671b8 !important;
  text-transform: capitalize;
  border-radius: 2px;
}

.input-style {
  width: 390px;
  height: 53px;
  border-radius: 2px;
  border: solid 2px #f0f0f0;
  background-color: #fafafa;
  font-size: 13px !important;
}

.Rectangle-1 {
  width: 390px;
  height: 83px;
  font-family: OpenSans-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.41;
  letter-spacing: 0.32px;
  text-align: left;
  color: #b3b3b3;
}
</style>